import EmailVerification from "./components/EmailVerification";

export default EmailVerification;
